import { render, staticRenderFns } from "./DeleteStaff.vue?vue&type=template&id=305722c0&scoped=true&"
import script from "./DeleteStaff.vue?vue&type=script&lang=js&"
export * from "./DeleteStaff.vue?vue&type=script&lang=js&"
import style0 from "./DeleteStaff.vue?vue&type=style&index=0&id=305722c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305722c0",
  null
  
)

component.options.__file = "DeleteStaff.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
